import DOMPurify from 'dompurify';

export function sanitizeText(text: string): string {
  return DOMPurify.sanitize(text, {
    ALLOWED_TAGS: ['em', 'strong', 'u', 'br'],
    ALLOWED_ATTR: [],
  });
}
